import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import {
  PERSONAL_DETAILS_LOADING,
  PERSONAL_DETAILS_SUCCESS,
  PERSONAL_DETAILS_FAILED,
  SAVE_PERSONAL_DETAILS_LOADING,
  SAVE_PERSONAL_DETAILS_SUCCESS,
  SAVE_PERSONAL_DETAILS_FAILED,
  UPLOAD_FILE_MULTIPART_LOADING,
  UPLOAD_FILE_MULTIPART_SUCCESS,
  UPLOAD_FILE_MULTIPART_FAILED,
  VERIFY_EMAIL_LOADING,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILED,
  VERIFY_COMPLETED_LOADING,
  VERIFY_COMPLETED_SUCCESS,
  VERIFY_COMPLETED_FAILED
} from "../Constants/personalDetailsConstants";
import { toast } from "react-toastify";

import { handleApiError } from "../Helper/actionHelper";

const errorMsg = "Something went wrong. Please try again.";

export const getPersonalDetails = () => async (dispatch) => {
  try {
    dispatch({ type: PERSONAL_DETAILS_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/profile",
      requestData,
      {
        headers: headers,
      }
    );

    await dispatch({
      type: PERSONAL_DETAILS_SUCCESS,
      payload: data,
    });

    handleApiError(data);
    return data;

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: PERSONAL_DETAILS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const sendPersonalDetails = (formData) => async (dispatch) => {
  try {
    dispatch({ type: SAVE_PERSONAL_DETAILS_LOADING });
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
    };
    for (var i in formData) {
      if (i === "customfields_data") {
        requestData[i] = formData[i];
      } else if (formData[i] && formData[i].length > 0) {
        requestData[i] = formData[i];
      }
    }
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/saveProfileDetails",
      requestData,
      {
        headers: headers,
      }
    );

    if (data.status === "success") {
      const msg = "Saved Successfully";
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    dispatch({
      type: SAVE_PERSONAL_DETAILS_SUCCESS,
      payload: data,
    });

    handleApiError(data);
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: SAVE_PERSONAL_DETAILS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const uploadFileViaMultipart =
  (mode, file, record = null) =>
  async (dispatch) => {
    try {
      dispatch({ type: UPLOAD_FILE_MULTIPART_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      let formData = new FormData();
      console.log(mode);
      formData.append("token", userLocalData.id);
      formData.append("mode", mode);
      if (file.lengh > 1) {
        for (let i = 0; i < file.length; i++) {
          formData.append(`${mode}[${i}]`, file[i]);
        }
      } else {
        formData.append(mode, file);
      }

      // in case of multiple file upload
      // formData.append(mode, file);

      // in case of multiple file upload

      for (let i = 0; i < file.length; i++) {
        formData.append(`${mode}[${i}]`, file[i]);
      }

      // in case of multiple file upload
      // formData.append(mode, file);

      if (mode === "check_documents") {
        formData.append("chkid", record.caseCheckId);
        formData.append("docid", record.docId);
      }

      console.log(formData);

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH + 
        "/CandidateApi/uploadFiles",
        formData,
        {
          headers,
        }
      );
      if (data.status === "success") {
        dispatch({
          type: UPLOAD_FILE_MULTIPART_SUCCESS,
          payload: data,
        });
        const msg = "Saved Successfully";
        if (mode != "uploadedSignature") {
          toast.success(data?.msg || msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }

      handleApiError(data);
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: UPLOAD_FILE_MULTIPART_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });

      handleApiError(error);
    }
  };

export const deleteSavePersonalDetails = () => (dispatch) => {
  dispatch({
    type: SAVE_PERSONAL_DETAILS_SUCCESS,
    payload: [],
  });
};

export const getEmailVerify = (record) => async (dispatch) => {
  try {
    const succMsg="Your Email has been verified";
    dispatch({ type: VERIFY_EMAIL_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      ...record,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/GenericApi/verifyEmail",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: VERIFY_EMAIL_SUCCESS,
      payload: data,
    });
    if(data.status == "success"){
    toast.success(data.data.remark, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  if(data.status == "error"){
    // toast.error("Invalid Email entered", {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
  }

    handleApiError(data);

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: VERIFY_EMAIL_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const getVerifyCompleted = (record,showMsg) => async (dispatch) => {
  try {
    const succMsg="Your Email has been verified";
    dispatch({ type: VERIFY_COMPLETED_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      ...record,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/GenericApi/verifyEmailStatus",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: VERIFY_COMPLETED_SUCCESS,
      payload: data,
    });
    if(data.data.isVerified == 1 && showMsg==0){
    toast.success(succMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  if(data.status == "error"){
    // toast.error("Invalid Email entered", {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
  }

    handleApiError(data);

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: VERIFY_COMPLETED_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const deleteVerifyCompleted = () => async (dispatch) => {
  dispatch({
    type: VERIFY_COMPLETED_SUCCESS,
    payload: [],
  });
};


export const getVerifyCompleted2 = (record) => async (dispatch) => {
  try {
    const succMsg="Your Email has been verified";
   

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      ...record,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/GenericApi/verifyEmailStatus",
      requestData,
      {
        headers: headers,
      }
    );

   
  //   if(data.data.isVerified == 1){
  //   toast.success(succMsg, {
  //     position: "top-right",
  //     autoClose: 5000,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     progress: undefined,
  //   });
  // }
  return data;

  if(data.status == "error"){
    // toast.error("Invalid Email entered", {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
  }

    handleApiError(data);

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    handleApiError(error);
  }
};

export const getUANVerify = (record, callback = () => {}) => async (dispatch) => {
  try {
    const succMsg="Your UAN has been verified";
    // dispatch({ type: VERIFY_EMAIL_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      ...record,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/verifyBasicUanDetails",
      requestData,
      {
        headers: headers,
      }
    );
    callback(data);
    // dispatch({
    //   type: VERIFY_EMAIL_SUCCESS,
    //   payload: data,
    // });
    if(data?.status === "success" || data?.data?.status == "success"){
    toast.success(data?.data?.msg || data?.msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  if(data?.data?.status === "failed" || data.status == "failed"){
    toast.error(data?.data?.msg || data?.data?.data, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

    handleApiError(data);

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    // dispatch({
    //   type: VERIFY_EMAIL_FAILED,
    //   payload:
    //     error.response && error.response.data.message
    //       ? error.response
    //       : error.response,
    // });
    handleApiError(error);
  }
};

export const getGenderListonPrefix = (payload = {}, callback = () => {}) => async (dispatch) => {
  try {
    console.log("prefix payload..", payload)
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    const requestData = {
      token: userLocalData.id,
      ...payload
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/genderListonPrefix",
      requestData,
      {
        headers: headers,
      }
    );
    callback(data);
    handleApiError(data);
    return data;

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    handleApiError(error);
  }
};
